<template>
    <b-card no-body>
        <b-tabs>

            <b-tab title="Movimentações">

                <b-card-body>
                    <b-card bg-variant="light">
                        <b-form-row @keyup.enter="load">
                            <b-col cols="4">
                                <lg-finder-page-unidade-administrativa v-model="form.departamentoSolicitante"
                                    :prefix="prefix + title + ' > '" id="finderDepartamentoSolicitante"
                                    @onselect="departamentoSolicitanteSelect" label="UA-Solicitante">
                                </lg-finder-page-unidade-administrativa>
                            </b-col>

                            <b-col cols="4">
                                <lg-finder-page-unidade-administrativa id="finderDepartamentoOrigem"
                                    @onselect="departamentoOrigemSelect" v-model="form.departamentoOrigem"
                                    :prefix="prefix + title + ' > '" label="UA-Origem">
                                </lg-finder-page-unidade-administrativa>
                            </b-col>

                            <b-col cols="3" class="text-right mt-2">
                                <b-button id="localizar" size="sm" style="height: 20px" pill variant="primary"
                                    @click="load">
                                    <div class="btn-size-alinhamento">
                                        <b-icon icon="search" />
                                    </div>
                                    <b-tooltip target="localizar" title="Localizar"></b-tooltip>
                                </b-button>

                                <b-button v-if="temPrivilegioInclusao()" id="novo" class="ml-3 mr-2 my-2"
                                    style="height: 20px" @click="showModal(null)" size="sm" pill variant="success">
                                    <div class="btn-size-alinhamento">
                                        <b-icon scale="1" icon="plus" />
                                    </div>
                                    <b-tooltip target="novo" title="Adicionar novo..."></b-tooltip>
                                </b-button>


                            </b-col>

                            <b-col cols="4">
                                <lg-finder-page-pessoa id="finderUsuarioSolicitante" v-model="form.usuarioSolicitante"
                                    @onselect="usuarioSolicitanteSelect" :prefix="prefix + title + ' > '"
                                    label="Usuário Solicitante:">
                                </lg-finder-page-pessoa>

                            </b-col>



                            <b-col cols="4">

                                <lg-finder-page-unidade-administrativa v-model="form.departamentoDestino"
                                    :prefix="prefix + title + ' > '" id="finderDepartamentoDestino"
                                    @onselect="departamentoDestinoSelect" label="UA-Destino">
                                </lg-finder-page-unidade-administrativa>



                            </b-col>

                            <b-col cols="3" class="text-right mt-2">
                                <b-button id="limpar" class="my-2" size="sm" style="height: 20px" pill variant="primary"
                                    @click="limpar">
                                    <div class="btn-size-alinhamento">
                                        <b-icon icon="eraser" />
                                    </div>
                                    <b-tooltip target="limpar" title="Limpar"></b-tooltip>
                                </b-button>

                                <b-button id="manual" class="ml-3 mr-2 my-2" size="sm" style="height: 20px" pill
                                    variant="primary" @click="manual">
                                    <div class="btn-size-alinhamento">
                                        <b-icon icon="question-circle" />
                                    </div>
                                    <b-tooltip target="manual" title="Manual"></b-tooltip>
                                </b-button>


                            </b-col>

                            <b-col cols="4">
                                <lg-finder-page-pessoa id="finderResponsavel" v-model="form.responsavel"
                                    @onselect="responsavelSelect" :prefix="prefix + title + ' > '" label="Responsável:">
                                </lg-finder-page-pessoa>
                            </b-col>

                            <lg-form-date invalidFeedback="A data de deve ser informada!" description=""
                                v-model="form.dataDe" label="De:" sm="2" />
                            <lg-form-date invalidFeedback="A data limite deve ser informada!" description=""
                                v-model="form.dataAte" label="Até:" sm="2" />

                            <b-col cols="4"></b-col>


                            <lg-form-input invalidFeedback="Informe uma nota fiscal válida!" description=""
                                v-model="form.numTombamento" label="Tombamento:" sm="2" />
                            <lg-form-input invalidFeedback="O ate deve ser informado!" description=""
                                v-model="form.numTombamentoAte" label="Até:" sm="2" />

                            <lg-form-select v-model="form.status" :loadFunction="statusList"
                                labelFormGroupBind="Status:" label="descricao" description=" " filterList="true" sm="4"
                                @input="load" style="z-index: 1000;" />

                            <b-col cols="4"></b-col>

                            <lg-form-input invalidFeedback="Informe uma nota fiscal válida!" description=""
                                v-model="form.numTombamentoSamp" label="Tombamento SAMP:" sm="4" />


                            <lg-form-select v-model="form.tipo" :loadFunction="tipoList" labelFormGroupBind="Tipo:"
                                label="descricao" description=" " filterList="true" sm="4" @input="load"
                                style="z-index: 999;" />

                        </b-form-row>


                        <b-table responsive class="mt-2" small :busy="this.busy" :items="this.records"
                            :fields="this.tableFields" :hover="true" show-empty>
                            <template #empty>
                                <p>
                                    Nenhum registro encontrado
                                </p>
                            </template>
                            <template #table-busy>
                                <div class="text-center text-primary my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                </div>
                            </template>

                            <template v-slot:cell(relatorios)="row">
                                <div class="d-flex align-items-center">

                                    <div v-b-tooltip.hover.bottom="'Guia de Transferência'">
                                        <img @click="gerarRelatorioGuia(row.item)" :src="pdf" class="img img--clickable"
                                            alt="pdf" />
                                    </div>
                                    <div v-if="podeGerarTermo(row.item)"
                                        v-b-tooltip.hover.bottom="'Termo de Transferência'">
                                        <img @click="gerarRelatorioTermo(row.item)" :src="pdf"
                                            class="img img--clickable" alt="pdf" />
                                    </div>
                                    <div v-if="mostrarRelatorioANTT"
                                        v-b-tooltip.hover.bottom="'Termo de Responsabilidade'">
                                        <img @click="gerarRelatorioTermoAntt(row.item)" :src="pdf"
                                            class="img img--clickable" alt="pdf" />
                                    </div>
                                </div>
                            </template>
                            <template v-slot:cell(id)="row">
                                <span @click="abrirDetalhe(row.item)" :id="'detalhes-' + row.index"
                                    style="cursor: pointer; color: blue; text-decoration: underline;">{{ row.item.id }}

                                </span>
                                <b-tooltip :target="'detalhes-' + row.index"
                                    title="Detalhes da Solicitação de Movimentação">
                                </b-tooltip>

                            </template>


                            <template v-slot:cell(destino)="">
                                <span>{{ departamentoOrigem.descricao }}</span>
                            </template>

                            <template v-slot:cell(relacionado)="{ item }">
                                <span>{{ item.relacionado === 1 ? "Sim" : "Não" }}</span>
                            </template>

                            <template v-slot:cell(finalizar)="row">
                                <b-button v-if="podeFinalizar(row.item) && temPrivilegioFinalizar()" class="my-2"
                                    size="sm" :id="`finalizar-${row.item.id}`" @click="finalizarSolicitacao(row.item)"
                                    variant="primary" pill>
                                    <b-icon icon="x-circle" />
                                    <b-tooltip :target="`finalizar-${row.item.id}`" title="Finalizar Movimentação">
                                    </b-tooltip>
                                </b-button>
                            </template>


                            <template v-slot:cell(enviar)="row">
                                <b-button v-if="isSolMovEditavel(row.item) && temPrivilegioEnviar()" class="my-2"
                                    size="sm" :id="`enviar-${row.item.id}`" @click="enviar(row.item)" variant="primary"
                                    pill title="Enviar...">
                                    <b-icon icon="box-arrow-right" />
                                    <b-tooltip :target="`enviar-${row.item.id}`" title="Enviar...">
                                    </b-tooltip>
                                </b-button>
                            </template>

                            <template v-slot:cell(editar)="row">
                                <b-button v-if="isSolMovEditavel(row.item) && temPrivilegioEditar()" class="my-2"
                                    size="sm" :id="`editar-${row.item.id}`" @click="showModal(row.item)"
                                    variant="primary" title="Editar..." pill>
                                    <b-icon icon="pencil-square" />
                                    <b-tooltip :target="`editar-${row.item.id}`" title="Editar Movimentação...">
                                    </b-tooltip>
                                </b-button>
                            </template>

                            <template v-slot:cell(remover)="row">
                                <b-button v-if="isSolMovEditavel(row.item)" :id="`excluir-${row.item.id}`" class="my-2"
                                    size="sm" @click="excluirPedido(row.item)" variant="primary" title="Excluir..."
                                    pill>
                                    <b-icon icon="trash2" />
                                    <b-tooltip :target="`excluir-${row.item.id}`" title="Excluir...">
                                    </b-tooltip>
                                </b-button>
                            </template>

                        </b-table>

                        <b-row style="margin-top: 12px" v-if="records && records.length > 0">
                            <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">
                                <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Página {{
                                    page }} de {{
                                        totalPage }} -
                                    {{ total }} registros</b-col>
                                <b-col cols="6"
                                    style="display: flex; align-items: center; font-size: 12px">Mostrando:&nbsp;
                                    <b-form-select size="sm" v-model="perPage" @change="() => this.load()"
                                        :options="perPageOptions">
                                    </b-form-select>
                                </b-col>
                            </b-col>
                            <b-col cols="6">
                                <div class="d-flex justify-content-end align-items-end">
                                    <b-pagination style="margin-bottom: 10px; margin-top: 10px" v-model="page"
                                        :per-page="perPage" :total-rows="total"></b-pagination>
                                </div>
                            </b-col>
                        </b-row>
                    </b-card>
                </b-card-body>

            </b-tab>
            <b-tab :title="'Tarefas(' + totalTarefas + ')'">

                <TarefaMovimentacao :executarMetodo="deveExecutarMetodo" @pesquisouTarefas="pesquisouTarefas">
                </TarefaMovimentacao>
            </b-tab>

        </b-tabs>
        <SolicitacaoMovimentacaoForm :id="id" @close="cancelar" v-if="showSolicitacao" :prefix="prefix + title + ' > '">
        </SolicitacaoMovimentacaoForm>

        <ToggleSolicitacaoMovimentacao :solicitacao="solicitacao" @close="fecharMoalDetalhe" v-if="abrirModalDetalhe"
            :prefix="prefix + title + ' > '">
        </ToggleSolicitacaoMovimentacao>
    </b-card>
</template>

<script>
import ToggleSolicitacaoMovimentacao from "./ToggleSolicitacaoMovimentacao.vue";
import SolicitacaoMovimentacaoForm from "./SolicitacaoMovimentacaoForm.vue";
import LgFinderPagePessoa from "@/components/Finders/LgFinderPagePessoa.vue";
import ResourceService from "@/core/api/ResourceService";
import LgFormDate from "@/core/components/Form/LgFormDate.vue";
import LgFormInput from "@/core/components/Form/LgFormInput.vue";
import LgFormSelect from "@/core/components/Form/LgFormSelect.vue";
import ConfirmMixin from "@/core/mixins/confirm";
import { FormResourceMixin, ListResourceMixin } from "@/core/mixins/resource";
import moment from "moment";
import LgFinderPageUnidadeAdministrativa from "@/components/Finders/LgFinderPageUnidadeAdministrativa.vue";
import TarefaMovimentacao from "./TarefaMovimentacao.vue";
import StatusSolicitacaoMovimentacaoIBPEnum from "@/core/utils/StatusSolicitacaoMovimentacaoIBPEnum";
import verificaPrivilegio from "@/utils/VerificaPrivilegio"
import PrivilegiosEnum from "@/core/utils/PrivilegioEnum"
import PdfIcon from "@/core/assets/icons/pdf.png";
import DownloadArquivoService from "@/core/utils/DownloadArquivoUtil";

export default {
    components: {
        ToggleSolicitacaoMovimentacao,
        TarefaMovimentacao,
        LgFormInput,
        LgFormDate,
        LgFormSelect,
        LgFinderPagePessoa,
        LgFinderPageUnidadeAdministrativa,
        SolicitacaoMovimentacaoForm
    },
    mixins: [ConfirmMixin, ListResourceMixin, FormResourceMixin],
    props: {
        title: { type: String, default: "Solicitação de Movimentação" },
        prefix: { tpye: String, default: "" }
    },
    data() {
        return {
            pdf: PdfIcon,
            mostrarRelatorioANTT: true,
            deveExecutarMetodo: false,
            abrirModalDetalhe: false,
            solicitacao: null,
            id: null,
            showSolicitacao: false,
            totalTarefas: "",
            params: {},
            perPage: 10,
            perPageOptions: [10, 25, 50, 100],
            departamentoOrigem: {},
            form: {
                usuarioSolicitante: {},
                dataDe: "",
                dataAte: "",
                responsavel: {},
                numTombamento: "",
                numTombamentoAte: "",
                numTombamentoSamp: "",
                status: { id: null, descricao: "Todos" },
                tipo: { id: null, descricao: "Todos" },
                departamentoSolicitante: {},
                departamentoOrigem: {},
                departamentoDestino: {},
            },
        };
    },
    async beforeMount() {
        this.$service = new ResourceService(`/api/solicitacaomovimentacao`);
        this.$serviceTipoMovimentacao = new ResourceService(
            `/api/tipomovimentacaoibp`
        );
        this.$statusService = new ResourceService(`/api/status/tipo/13`);
        this.departamentoOrigem = JSON.parse(localStorage.getItem("context")).departamento;

        this.$service.get(`countItensEmAbertoTelaInicial/${this.departamentoOrigem.id}`).then(response => {
            this.totalTarefas = response.data;
        });

        this.load();

        this.mostrarRelatorioANTT = (await new ResourceService(`/api/util`).get("is-cliente-antt")).data;

    },
    watch: {
        page() {
            this.load();
        },
    },
    computed: {
        tableFields() {
            var lista = [
                { key: "id", label: "Nº" },

                {
                    key: "dhCriacao",
                    label: "Data ",
                    formatter: (data) => moment(String(data)).format("DD/MM/YYYY"),
                },

                { key: "destino", label: "UA Origem" },

                { key: "descricao", label: " Descrição" },

                { key: "status.descricao", label: " Status" },

                { key: "tipoMovimentacao.descricao", label: "Tipo" },
                { key: "finalizar", label: " " },

                { key: "enviar", label: " " },
                { key: "editar", label: " " },
                { key: "remover", label: " " },
                { key: "relatorios", label: " " },
            ];

            return lista;
        },
    },
    methods: {

        async gerarRelatorioGuia(item) {
            this.busy = true;
            const resource = new ResourceService('/api/relatorio/gerar-relatorio-guia-transferencia');
            const { data } = await resource.getWithParams("PDF", item);
            DownloadArquivoService(data.arquivoBase64, data.nomeArquivo);

            this.busy = false;

        },
        async gerarRelatorioTermo(item) {
            this.busy = true;

            const resource = new ResourceService('/api/relatorio/gerar-relatorio-termo-transferencia');
            const { data } = await resource.getWithParams("PDF", item);
            DownloadArquivoService(data.arquivoBase64, data.nomeArquivo);
            this.busy = false;


        },
        async gerarRelatorioTermoAntt(item) {
            this.busy = true;

            const resource = new ResourceService('/api/relatorio/gerar-relatorio-termo-transferencia-antt');
            const { data } = await resource.getWithParams("PDF", item);
            DownloadArquivoService(data.arquivoBase64, data.nomeArquivo);
            this.busy = false;


        },
        async countTarefasAguardando() {
            this.busy = true;
            this.$service.get(`countItensEmAbertoTelaInicial/${this.departamentoOrigem.id}`).then(response => {
                this.totalTarefas = response.data;
                this.busy = false;
            });

        },


        pesquisouTarefas() {
            this.load();
        },


        fecharMoalDetalhe() {
            this.solicitacao = null;
            this.abrirModalDetalhe = false;
            this.load();
        },
        abrirDetalhe(item) {
            this.abrirModalDetalhe = true;
            this.solicitacao = item;
        },
        async enviar(item) {

            try {
                this.busy = true;
                await this.$service.put("enviar/" + item.id);
                this.busy = false;
                this.$notify({
                    type: "success",
                    message: "Solicitação enviada com sucesso!",
                })
                this.deveExecutarMetodo = true;

                this.load();
            } catch (error) {
                this.busy = false;
                this.$notify({
                    type: "danger",
                    message: error,
                });
            }

        },
        temPrivilegioInclusao() {
            return verificaPrivilegio(PrivilegiosEnum.SOLICITACAO_MOV_INCLUIR);

        },

        temPrivilegioEnviar() {
            return verificaPrivilegio(PrivilegiosEnum.SOLICITACAO_MOV_ENVIAR);

        },

        temPrivilegioEditar() {
            return verificaPrivilegio(PrivilegiosEnum.SOLICITACAO_MOV_EDITAR);

        },





        temPrivilegioFinalizar() {
            return verificaPrivilegio(PrivilegiosEnum.SOLICITACAO_MOV_FINALIZAR_MOV);

        },




        async finalizarSolicitacao(item) {

            let response = await this.$confirm(
                "Como administrador, você pode concluir esta movimentação e os bens permanecerão lotados em suas UA atuais. Deseja prosseguir?"
            )
            if (response) {
                try {
                    this.busy = true;
                    await this.$service.put("finaliza/" + item.id);
                    this.busy = false;
                    this.$notify({
                        type: "success",
                        message: "Solicitação finalizada com sucesso!",
                    })

                    this.load();
                } catch (error) {
                    this.busy = false;
                    this.$notify({
                        type: "danger",
                        message: error,
                    });
                }

            }

        },
        excluirPedido(item) {
            this.$removeResource(item);

        },
        podeFinalizar(item) {
            return item.status.id != StatusSolicitacaoMovimentacaoIBPEnum.FINALIZADO.value && item.status.id != StatusSolicitacaoMovimentacaoIBPEnum.CONCLUIDO_ADM.value;
        },

        podeGerarTermo(item) {
            return item.status.id == StatusSolicitacaoMovimentacaoIBPEnum.FINALIZADO.value || item.status.id == StatusSolicitacaoMovimentacaoIBPEnum.CONCLUIDO_ADM.value;
        },
        isSolMovEditavel(item) {
            if (item == null) {
                return false;
            }
            if (item.isBloquearAcoesTela) {
                return false;
            }
            if (item.status.id != StatusSolicitacaoMovimentacaoIBPEnum.EM_DIGITACAO.value) {
                return false;
            }
            if (item.departamento.id != JSON.parse(localStorage.getItem("context")).departamento.id) {
                return false;
            }
            return true;

        },

        showModal(item) {
            if (item)
                this.id = item.id;
            this.showSolicitacao = true;
        },
        cancelar() {
            this.id = null;
            this.showSolicitacao = false;
            this.load();
        },
        manual() {
            this.$notify({
                type: "warning",
                message: "Em desenvolvimento",
            });

        },
        limpar() {
            this.form = {
                usuarioSolicitante: {},
                dataDe: "",
                dataAte: "",
                responsavel: {},
                numTombamento: "",
                numTombamentoAte: "",
                numTombamentoSamp: "",
                status: {},
                tipo: {},
                departamentoSolicitante: {},
                departamentoOrigem: {},
                departamentoDestino: {},
            };
            this.load();
        },
        responsavelSelect(item) {
            this.form.responsavel = item;
            this.load()
        },
        departamentoDestinoSelect(item) {
            this.form.departamentoDestino = item;
            this.load();
        },
        departamentoSolicitanteSelect(item) {
            this.form.departamentoSolicitante = item;
            this.load();
        },
        departamentoOrigemSelect(item) {
            this.form.departamentoOrigem = item;

            if (!item || !item.id)
                this.departamentoOrigem = JSON.parse(localStorage.getItem("context")).departamento
            else
                this.departamentoOrigem = item;
            this.load();
        },
        usuarioSolicitanteSelect(item) {
            this.form.usuarioSolicitante = item;
            this.load();
        },

        async load() {

            this.params = {};

            if (this.form.departamentoSolicitante && this.form.departamentoSolicitante.id) {
                this.params.departamentoSolicitante =
                    this.form.departamentoSolicitante.id;
            }

            if (this.form.departamentoOrigem && this.form.departamentoOrigem.id) {
                this.params.departamentoOrigem = this.form.departamentoOrigem.id;
            }
            else
                this.params.departamentoOrigem = this.departamentoOrigem.id


            if (this.form.usuarioSolicitante && this.form.usuarioSolicitante.id) {
                this.params.usuarioSolicitante = this.form.usuarioSolicitante.id;
            }

            if (this.form.departamentoDestino && this.form.departamentoDestino.id) {
                this.params.departamentoDestino = this.form.departamentoDestino.id;
            }


            if (this.form.responsavel && this.form.responsavel.id) {
                this.params.responsavel = this.form.responsavel.id;
            }

            if (this.form.status && this.form.status.id && this.form.status.id) {
                this.params.status = this.form.status.id;
            }


            if (this.form.numTombamento && this.form.numTombamento != "") {
                this.params.numTombamento = this.form.numTombamento;
            }

            if (this.form.numTombamentoAte && this.form.numTombamentoAte != "") {
                this.params.numTombamentoAte = this.form.numTombamentoAte;
            }


            if (this.form.numTombamentoSamp && this.form.numTombamentoSamp != "") {
                this.params.tombamentoSamp = this.form.numTombamentoSamp;
            }

            if (this.form.dataDe && this.form.dataAte) {
                this.params.de = moment(String(this.form.dataDe)).format(
                    "DD/MM/YYYY"
                );
                this.params.ate = moment(String(this.form.dataAte)).format(
                    "DD/MM/YYYY"
                );
            }

            if (this.form.tipo && this.form.tipo.id) {
                this.params.tipo = this.form.tipo.id;
            }

            this.busy = true;
            await this.$loadResource({
                size: this.perPage,
                page: this.page,
                params: this.params,
            });
            this.countTarefasAguardando();

        },

        async visualizarItemBemPermanente(item) {
            this.$router.push({
                name: "visualizarItemBemPermanente",
                params: { id: item.id },
            });
        },

        async editarResource(item) {
            this.$router.push({ path: `${item.id}` });

            const value =
                item.status.id == 147 ||
                item.status.id == 148 ||
                (await this.$confirm(
                    `Deseja modificar o status do Registro de Entrada para “Em conferência"?`,
                    "Esta ação não poderá ser desfeita"
                ));
            if (value) {
                if (item.status.id != 147 && item.status.id != 148) {
                    //'Em Conferência' e 'Atesto'
                    this.alteraStatus(item, 147); //'Em Conferência'
                }
                this.$router.push({ path: `${item.id}` });
                // this.$router.push({ name: 'visualizarRegistroEntrada', params: { id: item.id } })
            }
        },


        async tipoList({ filter, page = 1 }) {
            return this.$serviceTipoMovimentacao.findAll({ filter, page, limit: 5 });
        },

        async statusList() {
            return this.$statusService.find();
        },

        async alteraStatus(item, statusId) {
            const { status } = this.$service.alteraStatus(item, statusId);
            if (status == 200) {
                this.$notify({
                    type: "success",
                    message: `Registro de entrada ${status.descricao}!`,
                });
            } else {
                this.$notify({
                    type: "danger",
                    message: `Erro ao alterar status para ${status.descricao}!`,
                });
                item.status = status;
            }
        },

        async editaResource(item) {
            if (!this.$router) {
                throw new Error("this.$router cannot be null");
            }
            this.$router.push({
                name: "editarRegistroEntradaAtesto",
                params: { id: this.$route.params.id, atestoId: item.id },
                query: {
                    bemConsumoId: item.itemBemConsumo ? item.itemBemConsumo.id : null,
                },
            });
        },
    },
};
</script>
